import { inter } from '@/config/fonts'

interface Props {
  title: string
  subtitle?: string
  classNameTitle?: string
  classNameContainer?: string
  classNameSubtitle?: string
}

export const Title = ({
  title,
  subtitle,
  classNameContainer,
  classNameTitle,
  classNameSubtitle,
}: Props) => {
  return (
    <div className={`${classNameContainer}`}>
      <div className={`${inter.className} ${classNameTitle}`}>{title}</div>
      <span>
        {subtitle && <h3 className={`${classNameSubtitle}`}>{subtitle}</h3>}
      </span>
    </div>
  )
}
//  text-xl mb-1 mt-0
